import { render } from "./Setting.vue?vue&type=template&id=022f9d00&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=022f9d00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-022f9d00"

export default script